export const getWaypointIconPopupAnchor = (name: string): [number, number] => {
  if (name.startsWith("map_icon")) return [0, -37];
  if (name.startsWith("map_shape")) return [0, -9];
  return [0, -44];
};
